//
export const ADD_PROTOBUF_MESSAGE = 'ADD_PROTOBUF_MESSAGE'
// 更新一条消息message
export const UPDATE_USER_MESSAGE = 'UPDATE_USER_MESSAGE'
// 删除一条消息message
export const DELETE_USER_MESSAGE = 'DELETE_USER_MESSAGE'
// 持久化一条会话thread
export const ADD_USER_THREAD = 'ADD_USER_THREAD'
// 更新链接状态
export const UPDATE_USER_CONNECTION = 'UPDATE_USER_CONNECTION'
// 增加会话未读数目
export const INCREASE_THREAD_UNREADCOUNT = 'INCREASE_THREAD_UNREADCOUNT'
// 关闭会话
export const CLOSE_USER_THREAD = 'CLOSE_USER_THREAD'
// 删除会话
export const REMOVE_USER_THREAD = 'REMOVE_USER_THREAD'
// 更新当前customer crm信息
export const UPDATE_CURRENT_CUSTOMER_INFO = 'UPDATE_CURRENT_CUSTOMER_INFO'
